export default __webpack_public_path__ + "static/KAINOS-d71b214a884fd2d9fb5af0030b74d601.png";